export const aspectRatios = ['1x1', '1x2', '2x1', '3x4', '4x3', '9x16', '16x9'];
export default { aspectRatios };
